import script from "./ChatDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ChatDialog.vue?vue&type=style&index=0&id=6d47060a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d47060a"]])

export default __exports__